import enUS from 'date-fns/locale/en-US';

var TODAY = function () {
  var today = Date.now();
  return {
    asNumber: today,
    asDate: new Date(today)
  };
}();
var DEFAULT_LONG_DATE = 'dd MMMMMMM yyyy';
var DEFAULT_SHORT_DATE = 'MM/dd/yyyy';
var DATE_INPUT_PLACEHOLDER_MONTH_FIRST = 'MM/DD/YYYY';
var DATE_INPUT_PLACEHOLDER_DAY_FIRST = 'DD/MM/YYYY';
var DATE_INPUT_PLACEHOLDER_YEAR_FIRST = 'YYYY/MM/DD';
var DEFAULT_DATE_INPUT_MASK = 'm/`d/`Y';
var DATE_INPUT_MASK_YEAR = 'Y/`m/`d';
var DEFAULT_LOCALE_SPEC = enUS;

export { DATE_INPUT_MASK_YEAR, DATE_INPUT_PLACEHOLDER_DAY_FIRST, DATE_INPUT_PLACEHOLDER_MONTH_FIRST, DATE_INPUT_PLACEHOLDER_YEAR_FIRST, DEFAULT_DATE_INPUT_MASK, DEFAULT_LOCALE_SPEC, DEFAULT_LONG_DATE, DEFAULT_SHORT_DATE, TODAY };
//# sourceMappingURL=index.esm.js.map
